import { GET_CURRENT_USER_PAGE_RESPONSIBILITIES } from "./actions";

export function CurrentUserPageResponsibilitiesReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_CURRENT_USER_PAGE_RESPONSIBILITIES}_FULFILLED`:
      return action.payload.data;
    default:
      return state;
  }
}
